
import { useState, useEffect } from 'react';

const backgroundImages = [
  {
    url: "https://readdy.ai/api/search-image?query=elegant%20modern%20medical%20consultation%20room%20with%20soft%20natural%20lighting%2C%20clean%20minimalist%20healthcare%20interior%20design%2C%20professional%20medical%20environment%20with%20warm%20white%20and%20blue%20tones%2C%20sophisticated%20medical%20office%20background%2C%20contemporary%20healthcare%20facility%20aesthetic%2C%20gentle%20lighting%20creating%20calm%20atmosphere&width=1920&height=1080&seq=hero-bg-1&orientation=landscape",
    alt: "Consulta médica elegante"
  },
  {
    url: "https://readdy.ai/api/search-image?query=sophisticated%20medical%20facility%20interior%20with%20modern%20architecture%2C%20clean%20lines%20and%20professional%20healthcare%20design%2C%20warm%20ambient%20lighting%20in%20medical%20consultation%20space%2C%20elegant%20healthcare%20environment%20with%20glass%20and%20white%20surfaces%2C%20contemporary%20medical%20center%20aesthetic&width=1920&height=1080&seq=hero-bg-2&orientation=landscape", 
    alt: "Instalaciones médicas modernas"
  },
  {
    url: "https://readdy.ai/api/search-image?query=premium%20medical%20office%20interior%20with%20elegant%20design%20elements%2C%20sophisticated%20healthcare%20facility%20with%20natural%20light%20filtering%20through%20windows%2C%20professional%20medical%20environment%20with%20clean%20modern%20aesthetic%2C%20calming%20healthcare%20space%20with%20blue%20and%20white%20color%20scheme&width=1920&height=1080&seq=hero-bg-3&orientation=landscape",
    alt: "Oficina médica premium"
  }
];

const doctors = [
  { id: 'dr-delgadillo', name: 'Dr. Juan Pablo Delgadillo Espejo', specialty: 'Urólogo Certificado', locations: ['belisario', 'abc'] },
  { id: 'dr-martinez', name: 'Dr. Omar Martínez Soltero', specialty: 'Urólogo Certificado', locations: ['cima', 'abc'] }
];

const locations = [
  { id: 'belisario', name: 'Hospital Belisario Domínguez' },
  { id: 'abc', name: 'Hospital Americas' },
  { id: 'cima', name: 'Centro de Salud La Cima' }
];

export default function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');

  // Carrusel automático de imágenes
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Generar fechas disponibles (próximos 30 días, solo días hábiles)
  const generateAvailableDates = () => {
    const dates = [];
    const today = new Date();
    
    for (let i = 1; i <= 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      
      // Solo días hábiles (lunes a viernes)
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        dates.push({
          value: date.toISOString().split('T')[0],
          label: date.toLocaleDateString('es-MX', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })
        });
      }
    }
    
    return dates.slice(0, 15); // Mostrar solo 15 fechas
  };

  const availableDates = generateAvailableDates();

  // Filtrar ubicaciones según el doctor seleccionado
  const getAvailableLocations = () => {
    if (!selectedDoctor) return locations;
    const doctor = doctors.find(d => d.id === selectedDoctor);
    return doctor ? locations.filter(loc => doctor.locations.includes(loc.id)) : locations;
  };

  const availableLocations = getAvailableLocations();


  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Carrusel de imágenes de fondo completo */}
      <div className="absolute inset-0 w-full h-full">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img 
              src={image.url}
              alt={image.alt}
              className="w-full h-full object-cover object-center"
            />
          </div>
        ))}
        {/* Overlay gradiente para mejorar legibilidad */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/60"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white/20"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
          {/* Contenido izquierdo */}
          <div className="text-[#111317]">
            <div className="mb-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
                <span className="text-[#1B84FF]">UroMás</span> Centro Urológico de Guadalajara
              </h1>
              <p className="text-xl md:text-2xl font-semibold text-[#0B2A4A] mb-2">
                La Clínica de Urología Líder en Guadalajara
              </p>
              <p className="text-lg text-gray-700">
                Dr. Juan Pablo Delgadillo Espejo y Dr. Omar Martínez Soltero
              </p>
            </div>
            
            <p className="text-lg md:text-xl mb-8 text-gray-700 leading-relaxed max-w-lg">
              UroMás Centro Urológico de Guadalajara, Jalisco - Centro urológico de excelencia con urólogos certificados. Especialistas en cirugía láser de próstata, disfunción eréctil, cálculos urinarios y urología masculina avanzada.
            </p>

            {/* Formulario de búsqueda inline */}
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 mb-8 border border-white/50">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                {/* Selector de Doctor */}
                <div className="relative">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                      <i className="ri-user-line text-blue-600 text-sm"></i>
                    </div>
                    <span className="text-sm font-medium text-gray-700">Especialista</span>
                  </div>
                  <select
                    value={selectedDoctor}
                    onChange={(e) => {
                      setSelectedDoctor(e.target.value);
                      setSelectedLocation(''); // Limpiar ubicación al cambiar doctor
                    }}
                    className="w-full px-3 py-2 pr-8 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm bg-white/90 appearance-none backdrop-blur-sm"
                  >
                    <option value="">Seleccionar urólogo</option>
                    {doctors.map((doctor) => (
                      <option key={doctor.id} value={doctor.id}>
                        {doctor.name}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 bottom-2 text-gray-400 pointer-events-none text-sm"></i>
                </div>

                {/* Selector de Fecha */}
                <div className="relative">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                      <i className="ri-calendar-line text-blue-600 text-sm"></i>
                    </div>
                    <span className="text-sm font-medium text-gray-700">Fecha</span>
                  </div>
                  <select
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    className="w-full px-3 py-2 pr-8 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm bg-white/90 appearance-none backdrop-blur-sm"
                  >
                    <option value="">Seleccionar fecha</option>
                    {availableDates.map((date) => (
                      <option key={date.value} value={date.value}>
                        {new Date(date.value).toLocaleDateString('es-MX', { 
                          day: 'numeric', 
                          month: 'long', 
                          year: 'numeric' 
                        })}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 bottom-2 text-gray-400 pointer-events-none text-sm"></i>
                </div>

                {/* Selector de Ubicación */}
                <div className="relative">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                      <i className="ri-map-pin-line text-blue-600 text-sm"></i>
                    </div>
                    <span className="text-sm font-medium text-gray-700">Clínica</span>
                  </div>
                  <select
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                    className="w-full px-3 py-2 pr-8 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm bg-white/90 appearance-none backdrop-blur-sm"
                    disabled={!selectedDoctor}
                  >
                    <option value="">
                      {selectedDoctor ? 'Seleccionar ubicación' : 'Primero selecciona un urólogo'}
                    </option>
                    {availableLocations.map((location) => (
                      <option key={location.id} value={location.id}>
                        {location.name}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 bottom-2 text-gray-400 pointer-events-none text-sm"></i>
                </div>
              </div>

              {/* Enlace de agendamiento */}
              <a
                href="https://cal.com/cita-doctor-nntskz/30min"
                target="_blank"
                rel="noopener noreferrer"
                data-component-name="Hero"
                className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-all duration-200 cursor-pointer whitespace-nowrap font-medium flex items-center justify-center shadow-lg hover:shadow-xl"
              >
                <i className="ri-calendar-check-line mr-2"></i>
                Agendar Consulta Urológica
              </a>
            </div>

            {/* Servicios destacados - horizontal */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-left">
                <div className="w-12 h-12 bg-blue-50/90 backdrop-blur-sm rounded-full flex items-center justify-center mb-3 shadow-sm">
                  <i className="ri-hospital-line text-blue-600 text-xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Centro Urológico Certificado</h3>
                <p className="text-sm text-gray-700">UroMás: El centro urológico líder de Guadalajara</p>
              </div>
              
              <div className="text-left">
                <div className="w-12 h-12 bg-blue-50/90 backdrop-blur-sm rounded-full flex items-center justify-center mb-3 shadow-sm">
                  <i className="ri-user-star-line text-blue-600 text-xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Urólogos Expertos</h3>
                <p className="text-sm text-gray-700">Los mejores urólogos certificados de Guadalajara</p>
              </div>
              
              <div className="text-left">
                <div className="w-12 h-12 bg-blue-50/90 backdrop-blur-sm rounded-full flex items-center justify-center mb-3 shadow-sm">
                  <i className="ri-flashlight-line text-blue-600 text-xl"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Tecnología Láser</h3>
                <p className="text-sm text-gray-700">Centro urológico con láser de última generación</p>
              </div>
            </div>
          </div>

          {/* Lado derecho - espacio para que la imagen de fondo se vea */}
          <div className="relative">
            {/* Elemento decorativo que permite ver mejor la imagen de fondo */}
            <div className="hidden lg:block">
              <div className="w-[420px] h-[720px] relative mx-auto">
                {/* Marco decorativo transparente */}
                <div className="absolute inset-0 border-2 border-white/30 rounded-2xl backdrop-blur-sm"></div>
                <div className="absolute inset-4 border border-blue-200/40 rounded-xl"></div>
                
                {/* Imagen flotante de persona - más grande y sin gradiente */}
                <div className="absolute inset-6 rounded-lg overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/7edb646391bab02956d1a26f30a10b94.png"
                    alt="Urólogo especialista en UROMÁS Guadalajara - Dr. Juan Pablo Delgadillo Espejo"
                    className="w-full h-full object-cover object-top rounded-lg shadow-2xl"
                  />
                </div>
                
                {/* Íconos decorativos removidos a solicitud */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Indicadores del carrusel */}
      <div className="absolute bottom-8 right-8 flex space-x-2 z-20">
        {backgroundImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 backdrop-blur-sm ${
              index === currentImageIndex 
                ? 'bg-blue-600 scale-110 shadow-lg' 
                : 'bg-white/60 hover:bg-white/80'
            }`}
          />
        ))}
      </div>
    </section>
  );
}
